export default class CartQuantity {
    constructor(element) {
        this.cartQuantity = element
        this.wrapperCartQuanity = document.querySelector('.navbar-icon-cart-quantity')
    }

    add(quantity) {
        this.cartQuantity.innerHTML = parseInt(this.cartQuantity.innerHTML) + quantity
        this.wrapperCartQuanity.classList.remove('hidden')
    }
}